import React from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle } from "react-feather";
import { Navbar } from "./Navbar";

const AppointmentConfirmed = () => {
  const navigate = useNavigate();

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-b from-sky-50 to-white flex items-center justify-center px-4">
        <div className="bg-white shadow-lg rounded-2xl p-10 max-w-md w-full text-center">
          <CheckCircle className="text-green-500 w-16 h-16 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-800 mb-2">You're All Set!</h1>
          <p className="text-gray-500 mb-2">
            Your resume review request has been received.
          </p>
          <p className="text-gray-500 mb-6">
            Our team will reach out to you within{" "}
            <span className="font-semibold text-gray-700">24 hours</span> to confirm your
            appointment. Check your inbox for a confirmation email.
          </p>
          <div className="space-y-3">
            <button
              onClick={() => navigate("/home")}
              className="w-full py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-500 transition"
            >
              Back to Home
            </button>
            <button
              onClick={() => navigate("/ats-resume")}
              className="w-full py-3 border border-gray-200 text-gray-600 rounded-xl font-semibold hover:bg-gray-50 transition"
            >
              View My Resume
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppointmentConfirmed;
